import { CrisisAlert, SmartDisplay } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Stack } from "@mui/system";
import { useEffect, useState } from "react";
import useSound from "use-sound";
import { useBaseContext } from "../context/BaseContext";

const ToolBox = () => {
  const { setIsModalOpen } = useBaseContext();

  const [style, setStyle] = useState({
    bottom: "-100px",
    zIndex: 9999999,
  });

  const [playGong] = useSound("/sound/gong.mp3");

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const viewportHeight = window.innerHeight;
      const mouseY = e.clientY;

      const start = 0.85 * viewportHeight;
      const end = 0.9 * viewportHeight;

      if (mouseY >= start && mouseY <= viewportHeight) {
        const progress = Math.min((mouseY - start) / (end - start), 1);
        const bottom = `${-100 + 105 * progress}px`;
        setStyle({
          bottom,
          zIndex: 9999999,
        });
      } else {
        reset();
      }
    };

    const reset = () => {
      setStyle({
        bottom: "-100px",
        zIndex: -1,
      });
    };

    const handleMouseLeave = () => reset();
    const handleWindowBlur = () => reset();

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseleave", handleMouseLeave);
    window.addEventListener("blur", handleWindowBlur);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseleave", handleMouseLeave);
      window.removeEventListener("blur", handleWindowBlur);
    };
  }, []);

  return (
    <Stack
      direction="row"
      gap={2}
      sx={{
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%)",
        transition: "all 0.3s ease",
        background: "rgba(0,0,0,0.5)",
        color: "#fff",
        padding: ".5rem 1rem",
        borderRadius: "15px",
        backdropFilter: "blur(10px)",
        boxShadow: 1,
        border: "2px solid rgba(255,255,255,0.5)",
        ...style,
      }}
    >
      <Button onClick={() => playGong()} variant="contained" color="primary">
        <CrisisAlert />
      </Button>

      <Button variant="contained" onClick={() => setIsModalOpen(true)}>
        <SmartDisplay />
      </Button>
    </Stack>
  );
};

export default ToolBox;
